/* eslint-disable camelcase */
export default {
  sponsor_flag: "(СП)",
  select_leg: "Выберите ногу",
  left_leg: "Левая нога",
  right_leg: "Правая нога",
  unknown_error: "Ошибка запроса даунлайн!",
};
